import MuiImage from './muiImage'

export default MuiImage
